import { FC, ReactNode, useMemo } from 'react';
import Tile from '.';
import { Stack } from '@mui/material';
import Icon from '@/components/icon';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import { openNewTab } from '@/lib/url-helpers';
import useUserSettings from '@/hooks/use-user-settings.hook';
import { PublicServiceModel } from '@/lib/models/public-service/public-service.model';
import { BaseTileProps } from './helpers';

const useStyles = createUseStyles({
  image: {
    height: 50,
  },
  imagePlaceholder: {
    width: 50,
  },
});

const PublicServiceTile: FC<BaseTileProps> = (props) => {
  const { tile } = props;
  const { resourceId } = tile;
  const styles = useStyles();

  const { publicServices, toggleRecent } = useUserSettings();

  const publicService = useMemo(() => {
    return publicServices.find(({ id }) => id === resourceId) || new PublicServiceModel();
  }, [publicServices, resourceId]);

  const { name, image, website } = publicService;
  const title = name;
  let ImageEl: ReactNode;

  if (image) {
    ImageEl = <img src={image} alt={title} className={styles.image} />;
  } else {
    const imagePlaceholderClass = classNames(styles.image, styles.imagePlaceholder);

    ImageEl = (
      <Stack alignItems="center" justifyContent="center" className={imagePlaceholderClass}>
        <Icon name="service" />
      </Stack>
    );
  }

  const handleClick = () => {
    openNewTab(website);
    toggleRecent(tile, true);
  };

  return <Tile onClick={handleClick} title={title} icon={ImageEl} {...props} />;
};

export default PublicServiceTile;
